module.exports = __webpack_public_path__ + "static/media/church.a7cdff8e.svg";